import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import {
    HeaderContentCard,
    LayoutCard,
    NavigationMenuCard,
    BehaviourCard,
} from '../cards';

/**
 * Body of the Navigation config modal — composes the four navigation-related
 * cards. Designed to be dropped inside any Dialog wrapper (the wrapper owns
 * its title/actions); this component is purely the content.
 *
 * value shape (each key optional, defaults handled by the cards):
 *   {
 *     headerContent:  { account, brands, wishlist, ... }
 *     layout:         { menuStyle, actionButtonsPosition, ... }
 *     navigationMenu: { categoriesShown, itemsPerRow, menuHeight, menuTextSize }
 *     behaviour:      { keepMenuVisibleWhileScrolling }
 *   }
 *
 * onChange(section, field, value) — fires per individual edit. The parent
 * decides where these end up (mini-api `setting` keys, in-memory only,
 * a future webshop-level config table — all TBD).
 */
const NavigationModal = ({
    value = {},
    onChange,
    availableCategories = [],
    theme,
    t,
}) => {
    // Curry the parent onChange so each card sees its own (field, value) pair
    // without having to know which "section" key it lives under in the parent.
    const cardOnChange = (section) => (field, val) => {
        if (onChange) onChange(section, field, val);
    };

    return (
        <Stack spacing={2}>
            <HeaderContentCard
                value={value.headerContent}
                onChange={cardOnChange('headerContent')}
                theme={theme}
                t={t}
            />
            <LayoutCard
                value={value.layout}
                onChange={cardOnChange('layout')}
                theme={theme}
                t={t}
            />
            <NavigationMenuCard
                value={value.navigationMenu}
                onChange={cardOnChange('navigationMenu')}
                availableCategories={availableCategories}
                theme={theme}
                t={t}
            />
            <BehaviourCard
                value={value.behaviour}
                onChange={cardOnChange('behaviour')}
                theme={theme}
                t={t}
            />
        </Stack>
    );
};

NavigationModal.propTypes = {
    value:               PropTypes.object,
    onChange:            PropTypes.func,
    availableCategories: PropTypes.array,
    theme:               PropTypes.string,
    t:                   PropTypes.func,
};

export default NavigationModal;
